import axios from "axios";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { RoleAddSchema } from "../../../ValidationSchema";
import ReactSelect from "../../../Components/PortalSelect";

const colourStyles = {
  control: (styles) => ({
    ...styles,
    border: "1px solid #bfc9d4",
    boxShadow: "#000 !important",
    borderRadius: "6px",
    padding: "4px",
    "&:hover": {
      border: "1px solid #bfc9d4",
    },
  }),
  multiValue: (styles) => ({
    ...styles,
    backgroundColor: "#606060",
  }),
  multiValueLabel: (styles) => ({
    ...styles,
    color: "#fff",
  }),
  multiValueRemove: (styles, { data }) => ({
    ...styles,
    color: "#000",
    "& > svg": {
      backgroundColor: "#fff",
      borderRadius: "10px",
      marginLeft: "2px",
      marginRight: "2px",
    },
    ":hover": {
      backgroundColor: data.color,
      color: data.color,
    },
  }),
  option: (styles) => ({
    ...styles,
    backgroundColor: "white",
    color: "#000",
    ":hover": {
      backgroundColor: "#f5f5f5",
    },
  }),
};

const SubCategoryAdd = () => {
  const Navigate = useNavigate();
  const [categoryData, setCategoryData] = useState([]);

  // ✅ match backend expected keys
  const [initialValues] = useState({
    subcategory_name: "",
    category_id: null,
  });

  const CategoriesData = () => {
    axios
      .get(`${process.env.REACT_APP_URL}/admin/category`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Token")}`,
        },
      })
      .then((res) => {
        setCategoryData(
          res?.data?.data?.categories.map((item) => ({
            label: item?.product_category_name || "Untitled",
            value: item?.product_category_id,
          }))
        );
      })
      .catch((err) => {
        if (err.response?.data?.message === "Unauthorized!") {
          Navigate("/");
        }
      });
  };

  const AddSubCategory = useFormik({
    initialValues,
    validationSchema: RoleAddSchema,
    onSubmit: (values) => {
      axios
        .post(
          `${process.env.REACT_APP_URL}/admin/sub_category`,
          {
            category_id: values.category_id,
            subcategory_name: values.subcategory_name,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("Token")}`,
            },
          }
        )
        .then((res) => {
          if (res.status === 201 || res.status === 200) {
            toast.success(`${res?.data?.message}`);
            Navigate("/admin/sub-category", { state: res.data.msg });
          }
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message || "Something went wrong");
        });
    },
  });

  useEffect(() => {
    CategoriesData();
  }, []);

  return (
    <div className="al">
      <Toaster position="top-center" reverseOrder={false} />

      <div className="al-head">
        <div>
          <h1 className="al-title">Add Sub Category</h1>
          <p className="al-sub">Create a new sub category under a parent category.</p>
        </div>
        <div className="al-head__actions">
          <button type="button" className="al-btn" onClick={() => Navigate(-1)}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>
            Back
          </button>
        </div>
      </div>

      <form onSubmit={AddSubCategory.handleSubmit}>
        <div className="al-card">
          <div className="al-cardhead">
            <div className="al-cardhead__icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.59 13.41 13.42 20.6a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" /><line x1="7" y1="7" x2="7.01" y2="7" /></svg></div>
            <h3 className="al-cardhead__title">Sub Category Details</h3>
          </div>

          <div className="al-form">
            <div>
              <label className="al-label">Subcategory Name <span className="al-req">*</span></label>
              <input className="al-input" type="text" placeholder="Enter Subcategory Name"
                value={AddSubCategory.values.subcategory_name}
                onChange={AddSubCategory.handleChange}
                onBlur={AddSubCategory.handleBlur}
                name="subcategory_name" />
              {AddSubCategory.errors.subcategory_name && AddSubCategory.touched.subcategory_name && (
                <div className="al-err">{AddSubCategory.errors.subcategory_name}</div>
              )}
            </div>

            <div>
              <label className="al-label">Parent Category <span className="al-req">*</span></label>
              <ReactSelect
                options={categoryData}
                isClearable={false}
                styles={colourStyles}
                components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                placeholder="Select Category"
                name="category_id"
                onChange={(e) => AddSubCategory.setFieldValue("category_id", e?.value)}
                value={categoryData.find((item) => item.value === AddSubCategory.values.category_id) || null}
              />
              {AddSubCategory.errors.category_id && AddSubCategory.touched.category_id && (
                <div className="al-err">{AddSubCategory.errors.category_id}</div>
              )}
            </div>
          </div>

          <div className="al-actionbar">
            <button type="button" className="al-btn" onClick={() => Navigate(-1)}>Cancel</button>
            <button type="submit" className="al-btn al-btn--primary">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>
              Create Sub Category
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default SubCategoryAdd;
